// extracted by mini-css-extract-plugin
export default {"button_see_more":"ProductContent_button_see_more__5TjJp","center":"ProductContent_center__PGeXs"};